(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/utils.js');
"use strict";


const {
  buttonChoices,
  signIndexToOutcome
} = svs.components.sport.tipsenShared;
const {
  wagerSystemTypes
} = svs.components.tipsen.engine.constants;
const {
  EventTypeField,
  EventTypeDistributionsFallback,
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  getDefinitionByProduct
} = svs.components.tipsen.engine.utils;
const getIsDistributionDisplay = selectedCouponChoice => selectedCouponChoice === buttonChoices.PEOPLE_DISTRIBUTION || selectedCouponChoice === buttonChoices.SYSTEM_DISTRIBUTION;
const getShouldShowInit = _ref => {
  let {
    isCompressed,
    isGoalCount,
    isSmall,
    selectedCouponChoice
  } = _ref;
  let shouldShowInit = false;
  if (!isGoalCount) {
    shouldShowInit = true;
  } else {
    shouldShowInit = !(isGoalCount && isCompressed && isSmall && getIsDistributionDisplay(selectedCouponChoice));
  }
  return shouldShowInit;
};
const getShouldShowCorrectResult = _ref2 => {
  let {
    isCompressed,
    isGoalCount,
    isSmall,
    selectedCouponChoice
  } = _ref2;
  let shouldShowCorrectResult = false;
  if (!isGoalCount) {
    shouldShowCorrectResult = isCompressed;
  } else {
    shouldShowCorrectResult = isCompressed || getIsDistributionDisplay(selectedCouponChoice) && !isSmall;
  }
  return shouldShowCorrectResult;
};
const getShouldShowCheckmark = _ref3 => {
  let {
    systemType,
    isResult,
    isGoalCount,
    isCompressed
  } = _ref3;
  return systemType === wagerSystemTypes.MSYS && !isResult && !isGoalCount && !isCompressed;
};
const getShouldShowTeamNames = _ref4 => {
  let {
    selectedCouponChoice,
    isCompressed
  } = _ref4;
  return selectedCouponChoice === buttonChoices.GAMES || !isCompressed;
};
const getProductDistribution = _ref5 => {
  var _eventStatistics$Even;
  let {
    eventStatistics,
    productId,
    drawNumber
  } = _ref5;
  let productDistribution = [];
  if (eventStatistics !== null && eventStatistics !== void 0 && (_eventStatistics$Even = eventStatistics[EventTypeField.Distributions]) !== null && _eventStatistics$Even !== void 0 && _eventStatistics$Even[productId]) {
    productDistribution = (eventStatistics[EventTypeField.Distributions][productId][drawNumber] ? eventStatistics[EventTypeField.Distributions][productId][drawNumber] : eventStatistics[EventTypeField.Distributions][productId][EventTypeDistributionsFallback] 
    ) || [];
  }
  return productDistribution;
};
const getEventCommentForCancelledGame = _ref6 => {
  let {
    resultForCurrentEvent,
    productId
  } = _ref6;
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  const isGoalCount = eventTypeId === EventTypeId.GOAL_COUNT;
  const index2Sign = signIndexToOutcome[eventTypeId || 1];
  const outcome = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome;
  let prefix = '';
  if (!isGoalCount) {
    prefix = outcome === 1 ? 'ett' : 'en';
  }
  let formattedOutcome = '';
  if (isGoalCount) {
    const nrOfGoals = (resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.home) + (resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.away);
    formattedOutcome = "".concat(nrOfGoals, " m\xE5l");
  } else {
    const outcome = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome;
    const outcomeSign = index2Sign[resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome];
    formattedOutcome = "".concat(outcomeSign, " ").concat(outcome !== 1 ? '\'a' : '');
  }
  return "Lottad till ".concat(prefix, " ").concat(formattedOutcome);
};
setGlobal('svs.components.tipsen.couponStatic.utils', {
  getEventCommentForCancelledGame,
  getIsDistributionDisplay,
  getProductDistribution,
  getShouldShowCheckmark,
  getShouldShowInit,
  getShouldShowCorrectResult,
  getShouldShowTeamNames
});

 })(window);